import { makeAutoObservable } from 'mobx';
import { ListType, Project } from '../components/reports/ReportProject';
import { ProjectReportRes } from '../types';
import apiConfig from '../api/routes';
import i18next from 'i18next';
import { notification, NotificationType } from '@iba-team/portal-react-components/dist';

class ReportPlanner {
  constructor() {
    makeAutoObservable(this);
  }
  isReportDownloading = false;
  projectList: {
    list: Project[],
    selectedItem: Project,
    selectedFilters: {
      showPendingRequests: boolean
    }
  } = {
      list: [],
      selectedItem: {
        name: '',
        projectId: 0,
        type: 'PROJECT'
      },
      selectedFilters: {
        showPendingRequests: false
      }
    };
  isDataFetched = false;
  projectData: ProjectReportRes = {
    dataGrid: [],
    workingDaysForProject: [],
    leaveTypesForParticipantCountry: []
  };

  downloadProjectReport = async (isPendingRequestVisible: boolean, reportType: string, projectId: number, yearMonth: string) => {
    let res;
    this.isReportDownloading = true;
    try {
      notification.open({
        type: NotificationType.INFO,
        description: i18next.t('MSG0016'),
      });
      res = await apiConfig.reportService.downloadProjectReportData(isPendingRequestVisible, reportType, projectId, yearMonth);
      this.isReportDownloading = true;
    }
    catch (e) {
      this.isReportDownloading = false;
    }
    finally {
      this.isReportDownloading = false;
    }
    return res;
  };

  getProjectList = async () => {
    const res = await apiConfig.reportService.getProjectList();
    this.projectList = res;
  };

  getProjectData = async (projectId: number, date: string, type: ListType, isPendingRequestVisible: boolean) => {
    try {
      switch (type) {
      case 'PROJECT':
        this.projectData = await apiConfig.reportService.getProjectManagerReport(projectId, date, isPendingRequestVisible);
        break;
      case 'CIRCLE':
        this.projectData = await apiConfig.reportService.getCircles(projectId, date, isPendingRequestVisible);
        break;
      case 'PLANNER_LIST':
        this.projectData = await apiConfig.reportService.getPlannerListReport(projectId, date, isPendingRequestVisible);
        break;
      }
      this.projectData.leaveTypesForParticipantCountry.sort();
      this.isDataFetched = true;
    }
    catch (e) {
      this.isDataFetched = true;
    }
  };
}


export const ReportPlannerStore = new ReportPlanner();
